import Templates from "../../components/templates/templates";

function TemplatesRoute() {
  return <Templates />;
}

export default TemplatesRoute;
